import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class AppIntegrationAccountLocationApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService: ApiService,
    private environmentUtilService: EnvironmentUtilService,
  ) {}

  get(params: { [param: string]: string | string[] }): Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/inventory-locations`,
      {
        params,
      },
    );
  }

  getByAppIntegrationAccountId(
    appIntegrationAccountId: number,
    params: { [param: string]: string | string[] },
  ): Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/${appIntegrationAccountId}/app-inventory-locations`,
      {
        params,
      },
    );
  }

  getById(
    appIntegrationAccountId: number,
    inventoryLocationId: number,
  ): Observable<any> {
    const url: string = `${this.environment.urlV2}/app-integration-accounts/${appIntegrationAccountId}/app-inventory-locations/${inventoryLocationId}`;

    return this.apiService.get(url, {});
  }

  syncLocations(params: { [param: string]: string | string[] }): Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/inventory-locations/sync`,
      {
        params,
      },
    );
  }

  bulkUpdateLocation(
    appIntegrationAccountId: number,
    inventoryLocationId: number,
    payload: {},
  ): Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/app-integration-accounts/${appIntegrationAccountId}/inventory-locations/${inventoryLocationId}/bulk-update-products`,
      body: payload,
    });
  }

  setDefaultLocation(
    appIntegrationAccountId: number,
    inventoryLocationId: number,
  ): Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/app-integration-accounts/${appIntegrationAccountId}/inventory-locations/${inventoryLocationId}/set-default`,
    });
  }
}
